import axios from "axios";
import { ENDPOINTS } from "./ENDPOINT";

const userService = {
  // =========================
  // USERS
  // =========================
  listUsers: async (params = {}) => {
    const response = await axios.get(`${ENDPOINTS.BASE}/users`, { params });
    return response.data;
  },

  getUserById: async (userId) => {
    const response = await axios.get(`${ENDPOINTS.BASE}/users/${userId}`);
    return response.data;
  },

  createUser: async (payload) => {
    const response = await axios.post(`${ENDPOINTS.BASE}/users`, payload);
    return response.data;
  },

  updateUser: async (userId, payload) => {
    const response = await axios.put(`${ENDPOINTS.BASE}/users/${userId}`, payload);
    return response.data;
  },

  deleteUser: async (userId) => {
    const response = await axios.delete(`${ENDPOINTS.BASE}/users/${userId}`);
    return response.data;
  },

  // =========================
  // ROLES
  // =========================
  listRoles: async () => {
    const response = await axios.get(`${ENDPOINTS.BASE}/users/roles/all`);
    return response.data;
  },

  createRole: async (name) => {
    const response = await axios.post(`${ENDPOINTS.BASE}/users/roles`, { name });
    return response.data;
  },

  deleteRole: async (id) => {
    const response = await axios.delete(`${ENDPOINTS.BASE}/users/roles/${id}`);
    return response.data;
  },

  // =========================
  // MODULES
  // =========================
  listModules: async () => {
    const response = await axios.get(`${ENDPOINTS.BASE}/users/modules/all`);
    return response.data;
  },

  // =========================
  // USER PERMISSIONS
  // =========================
  getUserPermissions: async (userId) => {
    const response = await axios.get(`${ENDPOINTS.BASE}/users/${userId}/permissions`);
    return response.data;
  },

  saveUserPermissions: async (userId, permissions) => {
    const response = await axios.post(
      `${ENDPOINTS.BASE}/users/${userId}/permissions`,
      { permissions }
    );
    return response.data;
  },
};

export default userService;